export const ProgramStartModal = {
  bindings: {
    datesForWeek: '<',
    subscription: '<',
    onSubmit: '&',
  },

  template: `
    <div
      id="modalStartProgram"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="Start Program"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <form
          name="form"
          ng-submit="$ctrl.onSubmit({ data: form.data })"
          novalidate>
          <form-input
            form="form"
            type="hidden"
            name="id"
            value="$ctrl.subscription.id"/>
          <form-input
            form="form"
            type="hidden"
            name="voomeProductId"
            value="$ctrl.subscription.voomeProductId"/>
          <div class="modal-content">
            <div class="modal-header text-center">
              <h5 class="modal-title m-auto">
                Start Program
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-left">
              <p>Pick the day you would like to start the program.</p>
              <form-radio-list
                form="form"
                name="startDate"
                value="form.data.startDate"
                list="$ctrl.datesForWeek"
                list-item-key="startDate"
                list-item-title="title"
                list-item-class="list-inline-item w-100 btn-radio-list"
                on-update="form.data.startDate = value">
              </form-radio-list>
            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button-primary is-inverse="true" data-dismiss="modal">
                Cancel
              </button-primary>
              <button-primary
                ng-type="submit"
                ng-disabled="!form.data.startDate">
                Submit
              </button-primary>
            </div>
          </div>
        </form>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Program/ProgramStartModal.js